import notifee from '@notifee/react-native';
import PushNotificationIOS from '@react-native-community/push-notification-ios';
import { Platform } from 'react-native';
import OrderUtils from 'utils/OrderUtils';
import HomeActionType from '../actionTypes/HomeActionType';
import Store from '../Store';

export default {
  updateCartItem: (cartItem) => {
    let { listCartItem = [] } = Store.getState().homeReducer;
    let found = false;
    listCartItem = listCartItem.map((e) => {
      if (OrderUtils.compare2ProductItem(e, cartItem)) {
        if (cartItem.amountAdd) cartItem.amount = e.amount + cartItem.amountAdd; // TH đặc biệt khi bấm thêm product từ danh sách hàng
        e = { ...e, ...cartItem };
        found = true;
      }
      return e;
    });
    if (!found) {
      cartItem = { ...cartItem, amount: 1 };
      listCartItem.push(cartItem);
    }
    listCartItem = listCartItem.filter((e) => e.amount > 0);
    Store.dispatch({ type: HomeActionType.UPDATE_CART_ITEMS, listCartItem });
  },

  updatePOSDeviceCartItem: (cartItem) => {
    let { listPOSDeviceCartItem = [] } = Store.getState().homeReducer;
    let found = false;
    listPOSDeviceCartItem = listPOSDeviceCartItem.map((e) => {
      if (e.id === cartItem.id) {
        if (cartItem.amountAdd) cartItem.amount = e.amount + cartItem.amountAdd;
        e = { ...e, ...cartItem, note: '' };
        found = true;
      }
      return e;
    });
    if (!found) {
      cartItem = { ...cartItem, amount: 1, price: cartItem.sellPrice, note: '' };
      listPOSDeviceCartItem.push(cartItem);
    }
    listPOSDeviceCartItem = listPOSDeviceCartItem.filter((e) => e.amount > 0);
    Store.dispatch({ type: HomeActionType.UPDATE_POS_DEVICES_CART_ITEMS, listPOSDeviceCartItem });
  },

  clearPOSDeviceCartItem: () => {
    Store.dispatch({ type: HomeActionType.UPDATE_POS_DEVICES_CART_ITEMS, listPOSDeviceCartItem: [] });
  },

  deleteCartItem: (cartItem) => {
    let { listCartItem = [] } = Store.getState().homeReducer;
    listCartItem = listCartItem.filter((e) => !OrderUtils.compare2ProductItem(e, cartItem));
    Store.dispatch({ type: HomeActionType.UPDATE_CART_ITEMS, listCartItem });
  },

  updateCartList: (listCartItem) => {
    Store.dispatch({ type: HomeActionType.UPDATE_CART_ITEMS, listCartItem });
  },

  updateDraftOrders: (draftOrders) => {
    Store.dispatch({ type: HomeActionType.UPDATE_DRAFT_ORDERS, draftOrders });
  },

  updateNetworkState: (isOnline) => {
    Store.dispatch({ type: HomeActionType.UPDATE_NETWORK_STATE, isOnline });
  },

  updateCountNotiy: (countNotify) => {
    Store.dispatch({ type: HomeActionType.UPDATE_COUNT_NOTIFY, countNotify });
    const badge = Math.max(0, parseInt(countNotify) || 0);
    try {
      if (Platform.OS === 'ios') PushNotificationIOS.setApplicationIconBadgeNumber(badge);
    } catch (e) {}
    try {
      notifee.setBadgeCount(badge);
    } catch (e) {}
  },

  updateEvents: (events) => {
    Store.dispatch({ type: HomeActionType.UPDATE_EVENTS, events });
  }
};
